module.exports = __webpack_public_path__ + "362a3dae422de3d59d1c438a6bc191f3.ttf";